import React from 'react';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import PasswordInput from '../../components/Inputs/PasswordInput';
import useApp from '../../store/app/appContext';

function UpdatePasswordForm() {


  const {
    updatePassword,
  } = useApp();

  const [passwords, _setPasswords] = React.useState({
    new: null,
    confirm: null,
  })

  const setPasswords = (data) => _setPasswords({ ...passwords, ...data })

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });
  
  const handleCancel = () => {
    setFormError({
      field: '',
      msg: ''
    });
  }

  const handleSubmit = async () => {
    if (passwords.new !== passwords.confirm) {
      setFormError({
        field: 'no-pw-match',
        msg: "Passwords don't match."
      })
      return;
    }
    if (passwords.new === '' || passwords.new === null) {
      setFormError({
        field: 'no-pw',
        msg: "Please enter a new password."
      })
      return;
    }
    await updatePassword(passwords);
  }

  return (
   <div className="w-full md:max-w-400">
      <div className='w-full mb-4'>
        <p tabIndex={0} role="heading" aria-level="1" aria-label="Set your password" className="text-xl md:text-4xl text-left text-secondary">
            Set your password
        </p>
      </div>
      <div className='flex flex-col justify-between mt-8'>
        <PasswordInput value={passwords.new} label={'New password'} onChange={(e) => setPasswords({ new: e.target.value })}/>
        <div className='mt-4'/>
        <PasswordInput value={passwords.confirm} label={'Confirm password'} onChange={(e) => setPasswords({ confirm: e.target.value })}/>
        {(formError.field === 'no-pw-match' || formError.field === 'no-pw') &&
        <span className="text-red-400 text-sm">{formError.msg}</span>
        }
        <div className='grid grid-cols-2 gap-x-2 mt-6'>
          <SecondaryButton onClick={handleCancel} text='Cancel'/>  
          <PrimaryButton onClick={handleSubmit} text='Update'/>
        </div>
      </div>
    </div>
  )
}

export default UpdatePasswordForm
 